module.exports = __webpack_public_path__ + "static/media/Jocelia.5584fbb9.PNG";